import MatchedMap from 'utilities/src/matchedMap';
import { useTheme, ThemeEnum } from '../../Theme';
import breadcrumbsCommonTheme from './common';
import breadcrumbsBlogTheme from './_blog';
import breadcrumbsSiteTheme from './_site';

const breadcrumbsThemes = new MatchedMap([
  [ThemeEnum.Blog, breadcrumbsBlogTheme],
  [ThemeEnum.Site, breadcrumbsSiteTheme],
]);

const useBreadcrumbsTheme = () => useTheme(breadcrumbsCommonTheme, breadcrumbsThemes);

export default useBreadcrumbsTheme;
